import { render, staticRenderFns } from "./MarkerUltimaPosicion.vue?vue&type=template&id=63a308ad&"
import script from "./MarkerUltimaPosicion.vue?vue&type=script&lang=ts&"
export * from "./MarkerUltimaPosicion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports